import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SummarizeService } from '../summarize.service';
// import { error } from 'console';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from 'app/notification-alert/alert.service';
import { AlertPopup } from 'app/app.config';
import { LlmService } from 'app/services/llm.service';
// import * as console from 'console';


@Component({
  selector: 'app-summarize-content',
  templateUrl: './summarize-content.component.html',
  styleUrls: ['./summarize-content.component.scss']
})
export class SummarizeContentComponent {

  summarizeForm:FormGroup=new FormGroup({});
  submitted:boolean=false;
  summarization:any;
  showPaginateSpinner:boolean=false;
 @Output() summaryResponse:EventEmitter<any>=new EventEmitter();
  constructor(private fb:FormBuilder,private summaryService:SummarizeService,private alert:AlertPopup,private llmService:LlmService){

  }

  ngOnInit(){
    this.summarizeForm = this.fb.group({
         'summary':['',Validators.required]
    });
  }
  chooseUploadFile(event:any){
    this.showPaginateSpinner=true;
    const files = event.target.files;
    let fileLLMformData = new FormData();
    fileLLMformData.append('clientid', localStorage.getItem('company_id'));
    fileLLMformData.append('file', files[0],files[0].name);
    this.summaryService.uploadSummaryPdf(fileLLMformData).subscribe((res:any)=>{
      this.showPaginateSpinner = false;

         let extractText=res['result'];
         if(extractText.length < 5){
          this.alert.showAlertMessage({"message":"Upload valid Pdf file"});
         }else{
          this.summarizeForm.controls['summary'].setValue(extractText);
         }

    },(error:HttpErrorResponse)=>{
      this.showPaginateSpinner = false;
    });
  }

  postSummary(){
    this.submitted=true;
    if(this.summarizeForm.valid){
      this.showPaginateSpinner = true;
      this.submitted=false;
       const payload = {
            "query":"summary of text "+`"`+this.summarizeForm.value['summary']+`"`
          }

      this.llmService.llmGenericQuery(payload).subscribe((result:any)=>{

           this.showPaginateSpinner = false;
           this.summarizeForm.reset();
          //  this.summaryResponse.emit(result['answer_html']);
              this.summaryResponse.emit(result['formatted_response']);
        },(error:HttpErrorResponse)=>{
          this.showPaginateSpinner = false;
        });
    }
  }

}
